/**
 * virtualBackground slice: 가상 배경 상태 관리
 * wehago-conference의 redux/modules/virtualBackground 에서 리팩토링
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { VirtualBackgroundType } from '@/types/store';

// re-export for backwards compatibility
export type { VirtualBackgroundType } from '@/types/store';

export interface UserBackgroundImage {
  fileId: string;   // Object Storage UUID (서버 저장용)
  id: string;       // 클라이언트 고유 ID
  src: string;      // base64 또는 Object Storage URL
}

export interface VirtualBackgroundState {
  type: VirtualBackgroundType;
  imageUrl: string | null;
  blurValue: number; // 0~100
  isEnabled: boolean;
  userImages: UserBackgroundImage[];
  userImagesLoaded: boolean;
}

const initialState: VirtualBackgroundState = {
  type: 'none',
  imageUrl: null,
  blurValue: 25,
  isEnabled: false,
  userImages: [],
  userImagesLoaded: false,
};

const virtualBackgroundSlice = createSlice({
  name: 'virtualBackground',
  initialState,
  reducers: {
    setBackground(
      state,
      action: PayloadAction<{
        type: VirtualBackgroundType;
        imageUrl?: string;
        blurValue?: number;
      }>
    ) {
      state.type = action.payload.type;
      state.isEnabled = action.payload.type !== 'none';
      if (action.payload.imageUrl !== undefined) {
        state.imageUrl = action.payload.imageUrl;
      }
      if (action.payload.blurValue !== undefined) {
        state.blurValue = action.payload.blurValue;
      }
    },

    setEnabled(state, action: PayloadAction<boolean>) {
      state.isEnabled = action.payload;
      if (!action.payload) {
        state.type = 'none';
      }
    },

    setUserImages(state, action: PayloadAction<UserBackgroundImage[]>) {
      state.userImages = action.payload;
      state.userImagesLoaded = true;
    },

    addUserImage(state, action: PayloadAction<UserBackgroundImage>) {
      state.userImages.push(action.payload);
    },

    removeUserImage(state, action: PayloadAction<string>) {
      state.userImages = state.userImages.filter((img) => img.id !== action.payload);
    },

    reset() {
      return initialState;
    },
  },
});

export const virtualBackgroundActions = virtualBackgroundSlice.actions;
export default virtualBackgroundSlice.reducer;
